import React, { Component } from 'react';
import { compose } from 'redux';
import styled, { withTheme } from 'styled-components';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { get } from 'lodash';
import Select from 'react-select';
import breakpoint from 'styled-components-breakpoint';
import EntityDropdownOption from 'components/molecules/EntityDropdownOption';

const EntityWrapper = styled('div')`
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    padding: 10px;
    ${breakpoint('xs', 'md')`
        justify-content: center;
        text-align: center;
        height: 50px;
        width: 100%;
        align-items: center;
        padding-top: 15px;
    `}
`;

const customStyles = props => ({
    option: provided => ({
        ...provided,
        borderBottom: `1px dotted ${props.theme.colors.lightgray}`,
        padding: '0 10px'
    }),
    placeholder: (provided, state) => ({
        ...provided,
        color: state.selectFocus ? 'hsl(0, 0%, 60%)' : 'hsl(0, 0%, 20%)'
    }),
    control: (provided, state) => ({
        ...provided,
        '&:hover': {
            boxShadow: state.menuIsOpen && `0 0 0 1px ${props.theme.global.colors.highlightColor}`,
            borderColor: state.menuIsOpen && `${props.theme.global.colors.highlightColor}`,
        },
        boxShadow: state.menuIsOpen && `0 0 0 1px ${props.theme.global.colors.highlightColor}`,
        borderColor: state.menuIsOpen && `${props.theme.global.colors.highlightColor}`,
        fontSize: '.8em'
    })
});

class EntityDropdownContainer extends Component {
    render() {
        const userEntities = this.props.userEntities;
        const navChange = value => this.props.push(value.path);

        return (
            <EntityWrapper>
                <div style={{ display: 'block', width: '100%' }}>
                    <Select
                        options={ userEntities }
                        onChange={value => navChange(value)}
                        styles={customStyles(this.props)}
                        components={{ Option: EntityDropdownOption }}
                        menuPlacement='auto'
                        placeholder='Search Your Dashboards ...'
                    />
                </div>
            </EntityWrapper>
        );
    }
}

const mapStateToProps = state => ({
    userEntities: get(state, 'users.currentUser.userEntities', []),
});

export default compose(
    withTheme,
    connect(mapStateToProps, { push })
)(EntityDropdownContainer);



// WEBPACK FOOTER //
// ./src/containers/EntityHomeSearchContainer.js